import React, { useEffect, useRef, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function ColumnChart(props) {
  const { data, title } = props;
  const chartComponentRef = useRef(null);

  const [primaryColor, setPrimaryColor] = useState('#000000'); // Cor padrão

  const series = [
    {
      name: 'Acessos',
      data: Object.entries(data).map(([name, count]) => ({
        name: name,
        y: count
      })),
      colorByPoint: true
    }
  ];

  useEffect(() => {
    const rootStyles = getComputedStyle(document.documentElement);
    const color = rootStyles.getPropertyValue('--color-primary-light').trim();
    if (color) {
      setPrimaryColor(color);
    }

    const handleResize = () => {
      if (chartComponentRef.current) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = {
    chart: {
      type: 'column',
      height: 300
    },
    credits: {
      enabled: false
    },
    title: {
      text: title
    },
    legend: {
      enabled: false
    },
    xAxis: {
      categories: Object.keys(data),
      title: {
        text: null
      },
      labels: {
        align: 'left',
        reserveSpace: true,
        style: {
          whiteSpace: 'nowrap',
          width: 112,
          textOverflow: 'ellipsis'
        }
      },
      gridLineWidth: 0,
      lineWidth: 0
    },
    yAxis: {
      title: {
        text: null
      },
      gridLineWidth: 1,
      lineWidth: 0,
      allowDecimals: false
    },
    series: series,
    plotOptions: {
      bar: {
        layout: 'vertical'
      },
      series: {
        pointPadding: 0.5, // Espaçamento entre as barras
        groupPadding: 0.5, // Espaçamento entre grupos de barras
        pointWidth: 30, // Largura das barras horizontalmente
        pointHeight: 80 // Altura das barras verticalmente (aumenta a espessura)
      }
    },
    colors: [primaryColor],
    pointWidth: 50 // Largura da barra
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      ref={chartComponentRef}
    />
  );
}
